<div class="header" *ngIf="label">
    <div class="header-label">
        <div class="header-label-title">
            {{label | translate: i18nParams}}
        </div>
    </div>
</div>
<div class="main">
    <ng-content select="fui-column"></ng-content>
</div>

